import { css } from '@emotion/react';
import React from 'react';

import { fontStyles } from '~src/theme/fontStyles';

import { CartItem } from '../../api/api';
import { colors } from '../theme/colors';

interface CartItemProps {
  cartItem: CartItem;
}

export const CartItemComponent: React.FC<CartItemProps> = ({ cartItem }) => {
  const image = cartItem.image_url ? (
    <img alt={cartItem.name} css={styles.image} src={cartItem.image_url} />
  ) : null;

  return (
    <div css={styles.wrapper}>
      {image && <div css={styles.imageWrapper}>{image}</div>}
      <div css={styles.textWrapper}>
        <span>{cartItem.name}</span>
        {cartItem.quantity !== undefined && <span>× {cartItem.quantity}</span>}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    flexShrink: 0,
  },
  imageWrapper: {
    border: `1px solid ${colors.neutral85}`,
    height: '50px',
    width: '40px',
    minWidth: '40px',
    marginRight: '12px',
  },
  textWrapper: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    ...fontStyles.px14_20,
  }),
  image: {
    height: '100%',
    width: '100%',
  },
};
